import React, { useState } from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ICurrentUser from "../../entities/helper/ICurrentUser";
import IPlan from "../../entities/IPlan";
import { IParametros } from "../../entities/IParametros";
import { usePromiseEffect } from "../../helpers/promiseEffect";
import { cognitoUserInfo, cognitoUserToken } from "../../helpers/userHelper";
import { API_ADMIN_PARAMETROS, API_PROVEEDOR_GET_PLANIFICACIONES, URL_PROVIDER, URL_SUPPORT } from "../../helpers/variableHelper";
import { getAPI, postAPI } from "../../helpers/httpHelper";
import { E_EstadoFormPrograma, E_EstadoPlanificacion } from "../../enums/E_EstadoProveedor";
import IPlanificacion from "../../entities/IPlanificacion";
import { TextField } from "@fluentui/react";
import Loading from "../../cross/Loading";

const MySwal = withReactContent(Swal);
interface IAgregarProgramaProps {
  plan?: IPlan;
  id_evaluacion: number;
  planif?: IPlanificacion;
  porcentajeTest?: number;
  descriptionTest?: string;
  estadoTest?: number;
  loading?: boolean;
  pond?: any[];
  is_Test?: boolean;
  evaluacion?: any;
}

interface Evaluaciones {
  ID: number;
  OBSERVACIONES: string;
  PUNTAJE_OBTENIDO: number;
  CLASIFICACION: string;
  CALIFICACIONES: Array<Calificacion>;
}

interface Calificacion {
  ID: number;
  PONDERACION: number;
  NOTA: number;
  TITULO: string;
}

interface IParametroPlan {
  ID: number;
  ID_PARAMETRO: number;
  TITULO: string;
  PONDERACION: number;
  NOTA: number;
}
export default function Evaluacion({// NOSONAR "Se aplica en esta linea ya que SONAR nos arroja 129 como valor de complejidad cognitiva. El componente de evaluación utiliza una gran cantidad de lógica dada sus etapas"
  plan,
  evaluacion,
  id_evaluacion,
  planif,
  porcentajeTest,
  estadoTest,
  loading,
  pond,
  descriptionTest = "",
  is_Test = false,
}: IAgregarProgramaProps) {
  const userInfo = cognitoUserToken();

  const [token, setToken] = useState("");
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [isLoading, setIsLoading] = useState(loading || false);
  const [isSendingData, setIsSendingData] = useState(false);
  const [parametros, setParametros] = useState<Array<IParametros>>([]);
  const [selectedParams, setSelectedParams] = useState<Array<IParametroPlan>>([]);
  const [deletedParams, setDeletedParams] = useState<Array<IParametroPlan>>([]);
  const [estado, setEstadoPrograma] = useState<E_EstadoFormPrograma>(estadoTest || E_EstadoFormPrograma.Lectura);
  const [porcentaje, setPorcentaje] = useState(porcentajeTest || 0);
  const [calificacion, setCalificacion] = useState("");

  const [observacion, setObservacion] = useState(descriptionTest);
  const [observacionAnterior, setObservacionAnterior] = useState(descriptionTest);
  let search = new URLSearchParams(window.location.search);
  const id_planificacion = parseInt(search.get("id_planificacion") || "0");
  usePromiseEffect(async () => {
    let token = await userInfo;
    setToken(token);
    let currUser = await cognitoUserInfo();
    setCurrentUser(currUser);

    let resultParametros: Array<IParametros> = [];
    if (!is_Test) {
      resultParametros = (
        await getAPI(`${URL_SUPPORT}${API_ADMIN_PARAMETROS}/GetByProducto`, { Authorization: `Bearer ${token}` }, { ID: planif?.ID_PRODUCTO })
      ).result.data;
    }
    setParametros(resultParametros);

    if (id_evaluacion > 0) {
      let resultevaluacion: any = is_Test
        ? evaluacion
        : await getAPI(`${URL_PROVIDER}${API_PROVEEDOR_GET_PLANIFICACIONES}/getevaluacion/${id_evaluacion}`, { Authorization: `Bearer ${token}` });

      let l_evaluaciones = resultevaluacion.result.data;

      if (l_evaluaciones !== undefined) {
        let paramPlan: Array<IParametroPlan> = [];
        l_evaluaciones.forEach((ev: any) => {
          ev.CALIFICACIONES.forEach((c: any) => {
            paramPlan.push({ ID: c.ID, ID_PARAMETRO: c.ID_PARAMETRO, TITULO: c.TITULO, NOTA: c.NOTA, PONDERACION: c.PONDERACION } as IParametroPlan);
          });
          if (ev?.OBSERVACIONES !== "") {
            setObservacion(ev?.OBSERVACIONES);
            setObservacionAnterior(ev?.OBSERVACIONES);
          } else {
            setObservacion("N/A");
          }
        });
        setSelectedParams(paramPlan);

        let evaluacion = l_evaluaciones.pop();
        if (evaluacion !== undefined) {
          setCalificacion(evaluacion?.CLASIFICACION);
          setPorcentaje(evaluacion?.PUNTAJE_OBTENIDO);
        }
      }
      if (
        planif?.ID_ESTADO === E_EstadoPlanificacion.PlanInformado &&
        (planif?.EVALUADOR_LIDER === currUser.email || isEvaluator(planif?.EVALUADORES, currUser))
      ) {
        setEstadoPrograma(E_EstadoFormPrograma.Agregar);
      }
    } else if (
      planif?.ID_ESTADO === E_EstadoPlanificacion.PlanInformado &&
      (planif?.EVALUADOR_LIDER === currUser.email || isEvaluator(planif?.EVALUADORES, currUser))
    ) {
      setEstadoPrograma(E_EstadoFormPrograma.Agregar);
    }

    setIsLoading(false);
  }, []);

  const isEvaluator = (evaluators?: string, currUser?: ICurrentUser) => {
    if (evaluators !== undefined && evaluators !== null) {
      let arrayEvaluadores = evaluators.split("; ");
      const isEvaluator = arrayEvaluadores.some((evaluator) => evaluator.trim() === currUser?.email);
      return isEvaluator;
    }
    return false;
  };

  const fireError = (title: string, msg: string) => {
    MySwal.fire({
      html: (
        <div>
          <h3>{title}</h3>
          <p>{msg}</p>
        </div>
      ),
      text: "",
      icon: "error",
      showCloseButton: true,
    });
  };

  const handleGuardar = async (id_estado: number, is_test = false) => {
    let paramPlan = selectedParams;
    if (is_test) {
      paramPlan = pond ?? [];
    }

    if (paramPlan.length === 0) {
      fireError("Error al guardar la evaluación", "Debe agregar los parámetros de ponderación");
      return;
    }

    let estaPonderacionVacia = paramPlan.some((acc) => acc.PONDERACION === undefined);
    if (estaPonderacionVacia) {
      fireError("Error al guardar la evaluación", "Hay un registro que el campo Poderación esta vacio");
      return;
    }
    let estaNotaVacia = paramPlan.some((acc) => acc.NOTA === undefined);
    if (estaNotaVacia) {
      fireError("Error al guardar la evaluación", "Hay un registro que el campo Nota esta vacio");
      return;
    }

    let sum = paramPlan.reduce((acc, curr) => {
      return acc + Number(curr.PONDERACION);
    }, 0);

    if (sum < 100) {
      fireError("Error al guardar la evaluación", "La ponderación debe sumar 100%");
      return;
    }

    if (sum > 100) {
      fireError("Error al guardar la evaluación", "La ponderación no debe ser superior al 100%");
      return;
    }

    if (porcentaje < 95 && observacion === "") {
      fireError("Error al guardar evaluación", "Debe agregar una descripción");
      return;
    }

    setIsSendingData(true);
    setIsLoading(true);

    let params = {
      ID: id_evaluacion !== 0 ? id_evaluacion : null,
      ID_PLANIFICACION: id_planificacion,
      OBSERVACIONES: observacion,
      PUNTAJE_OBTENIDO: porcentaje,
      CLASIFICACION: calificacion,
    };

    let p = {
      EVALUACION: params,
      CALIFICACIONES: paramPlan,
      CALIFICACIONES_ELIMINADAS: deletedParams,
    };

    try {
      let r = (
        await postAPI(
          `${URL_PROVIDER}${API_PROVEEDOR_GET_PLANIFICACIONES}/postevaluacion`,
          p,
          { Authorization: `Bearer ${token}` },
          { avanzar: id_estado === 1 ? false : true }
        )
      ).result;

      console.log(r);
      setIsLoading(false);
      window.location.href = `proveedores/home`;
    } catch (e: any) {
      MySwal.fire({
        html: (
          <div>
            <h3>Error al crear programa</h3>
            <p>{e.response.data.msg}</p>
          </div>
        ),
        text: "",
        icon: "error",
        showCloseButton: true,
      });

      setIsLoading(false);
    }
  };

  const selected = (param: IParametros, checked: boolean) => {
    let newSelectedParams = selectedParams;
    let newDeletedParams = deletedParams;
    if (checked) {
      let deletedParam = newDeletedParams.filter((p) => {
        return p.ID_PARAMETRO === param.ID;
      });
      if (deletedParam.length > 0) {
        newSelectedParams.push(deletedParam[0]);
        newDeletedParams = newDeletedParams.filter((p) => {
          return p.ID_PARAMETRO != param.ID;
        });
      } else {
        let calificacion = {
          ID: 0,
          ID_PARAMETRO: param.ID,
          TITULO: param.TITULO,
          PONDERACION: param.PONDERACION,
          NOTA: param.NOTA,
        } as IParametroPlan;
        newSelectedParams.push(calificacion);
      }
    } else {
      let selectedParam = newSelectedParams.filter((p) => {
        return p.ID_PARAMETRO === param.ID;
      });
      if (selectedParam.length > 0) {
        newDeletedParams.push(selectedParam[0]);
        newSelectedParams = newSelectedParams.filter((p) => {
          return p.ID_PARAMETRO != param.ID;
        });
      }
    }
    setDeletedParams([...newDeletedParams]);
    setSelectedParams([...newSelectedParams]);
  };

  const fillTable = (ID: number, ID_PARAMETRO: number, TITULO: string, value: string, type: string, is_test = false) => {
    let paramPlan = selectedParams;
    console.log(ID, ID_PARAMETRO, TITULO);
    console.log("paramPlan", paramPlan);

    if (is_test) {
      paramPlan = pond ?? [];
    }
    let valueInt = parseInt(value);
    let pPlan = paramPlan
      .filter((p) => {
        return p.ID_PARAMETRO === ID_PARAMETRO;
      })
      .pop() as any;
    console.log(pPlan);

    if (pPlan !== undefined) {
      paramPlan.forEach((p: any) => {
        if (p.ID_PARAMETRO === ID_PARAMETRO) {
          p[type] = value;
        }
      });
    } else {
      paramPlan.push({
        ID: ID,
        ID_PARAMETRO: ID_PARAMETRO,
        TITULO: TITULO,
        NOTA: type === "NOTA" ? valueInt : 0,
        PONDERACION: type === "PONDERACION" ? valueInt : 0,
      });
    }

    if (paramPlan) {
      let sum = 0;
      let sumaPonderacion = 0;
      paramPlan.forEach((p) => {
        sum = sum + (p.NOTA * p.PONDERACION) / 100;
        sumaPonderacion = sumaPonderacion + parseInt(p.PONDERACION.toString());
      });
      if (sumaPonderacion === 100) {
        let porcentaje = Math.round((sum * 100) / 5);
        setPorcentaje(porcentaje);
        let calidad = "";
        if (porcentaje >= 95) {
          calidad = "Muy bueno";
        } else if (porcentaje < 95 && porcentaje >= 70) {
          calidad = "Bueno";
        } else if (porcentaje < 70 && porcentaje >= 50) {
          calidad = "Regular";
        } else if (porcentaje < 50 && porcentaje >= 21) {
          calidad = "Malo";
        } else if (porcentaje < 21 && porcentaje >= 0) {
          calidad = "Muy malo";
        }

        setCalificacion(calidad);
      }
    }
    setSelectedParams([...paramPlan]);
  };

  return isLoading ? (
    <Loading />
  ) : (
    <div className="row">
      <button
        hidden={true}
        data-testid="btnformvalidation"
        onClick={() => {
          handleGuardar(1, true);
        }}></button>
      <button
        hidden={true}
        data-testid="btnfilltable"
        onClick={() => {
          fillTable(1, 1, "", "", "", true);
          selected(
            {
              ID: 1,
              TITULO: "string",
              ACTIVO: true,
              NOTA: 1,
              PONDERACION: 1,
            } as IParametros,
            true
          );
          selected(
            {
              ID: 1,
              TITULO: "string",
              ACTIVO: true,
              NOTA: 1,
              PONDERACION: 1,
            } as IParametros,
            false
          );
        }}></button>
      <div className="col-12">
        <div className="rounded bg-white p-2 shadow">
          <div className="container-fluid mb-4">
            <h1 className="titPrincipal colorTit">Evaluación</h1>

            <div className="card bg-light border p-3 pt-2 mt-2">
              <div className="row ajusteInput">
                <div className="col-12">
                  <h6>
                    <span className="textSeccion">Programa anual</span>
                  </h6>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-12 mb-1">
                  <div className="col-12">
                    <h6>
                      <span className="textSeccion">{planif?.CORRELATIVO}</span>
                    </h6>
                  </div>
                  <div className="col-4">
                    <table className="table table-hover tablaTLC table-sm">
                      <thead>
                        <tr>
                          <th>Cumplimiento</th>
                          <th>Clasificación</th>
                          <th>Nota</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td width="40%">95% - 100%</td>
                          <td width="35%">A: Muy bueno</td>
                          <td width="25%">5</td>
                        </tr>
                        <tr>
                          <td width="40%">70% - 94%</td>
                          <td width="35%">B: Bueno</td>
                          <td width="25%">4</td>
                        </tr>
                        <tr>
                          <td width="40%">50% - 69%</td>
                          <td width="35%">C: Regular</td>
                          <td width="25%">3</td>
                        </tr>
                        <tr>
                          <td width="40%">21% - 49%</td>
                          <td width="35%">D: Malo</td>
                          <td width="25%">2</td>
                        </tr>
                        <tr>
                          <td width="40%">0% - 20%</td>
                          <td width="35%">E: Muy malo</td>
                          <td width="25%">1</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  {planif?.ID_ESTADO === E_EstadoPlanificacion.PlanInformado && (
                    <div className="col-8">
                      {parametros.map((p) => {
                        return (
                          <div key={p.ID} className="col-sm-12 col-md-6 col-lg-6">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="ID"
                                disabled={
                                  (id_evaluacion > 0 && planif?.ID_ESTADO !== E_EstadoPlanificacion.PlanInformado) ||
                                  estado === E_EstadoFormPrograma.Lectura
                                }
                                checked={selectedParams
                                  .map((d) => {
                                    return d.ID_PARAMETRO;
                                  })
                                  .includes(p.ID)}
                                onChange={(e) => {
                                  selected(p, e.currentTarget.checked);
                                }}
                              />
                              <span style={{ fontSize: "11px" }}>{p.TITULO}</span>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>

                <div className="col-sm-12 col-md-12 col-lg-12 mb-1">
                  <table className="table table-hover tablaTLC table-sm">
                    <thead>
                      <tr>
                        <th>Parámetro</th>
                        <th>Ponderación</th>
                        <th>Nota</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedParams.map((p: IParametroPlan) => {
                        return (
                          <tr key={p.ID_PARAMETRO}>
                            <td width="60%">{p.TITULO}</td>
                            <td width="20%">
                              {id_evaluacion > 0 && planif?.ID_ESTADO !== E_EstadoPlanificacion.PlanInformado ? (
                                <label>{p.PONDERACION}</label>
                              ) : (
                                <input
                                  disabled={planif?.PROVEEDOR_RESPONSABLE === currentUser?.email}
                                  type="number"
                                  defaultValue={p.PONDERACION}
                                  min={1}
                                  max={100}
                                  onChange={(e) => {
                                    let val = e.currentTarget.valueAsNumber;
                                    if (val < 1 || val > 100) {
                                      e.target.value = "";
                                    }
                                    fillTable(p.ID, p.ID_PARAMETRO, p.TITULO, e.currentTarget.value, "PONDERACION");
                                  }}
                                />
                              )}
                            </td>
                            <td width="20%">
                              {id_evaluacion > 0 && planif?.ID_ESTADO !== E_EstadoPlanificacion.PlanInformado ? (
                                <label>{p.NOTA}</label>
                              ) : (
                                <input
                                  disabled={planif?.PROVEEDOR_RESPONSABLE === currentUser?.email}
                                  type="number"
                                  defaultValue={p.NOTA}
                                  min={1}
                                  max={5}
                                  onChange={(e) => {
                                    let val = e.currentTarget.valueAsNumber;
                                    if (val < 1 || val > 5) {
                                      e.target.value = "";
                                    }
                                    fillTable(p.ID, p.ID_PARAMETRO, p.TITULO, e.currentTarget.value, "NOTA");
                                  }}
                                />
                              )}
                            </td>
                          </tr>
                        );
                      })}{" "}
                    </tbody>
                  </table>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                  <label>Porcentaje obtenido</label>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-8 mb-1">{porcentaje}%</div>

                <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                  <label>Calificaciones</label>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-8 mb-1">{calificacion}</div>
                <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                  <label>Observaciones </label>
                </div>

                <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                  {planif?.ID_ESTADO === E_EstadoPlanificacion.PlanInformado ? (
                    <>
                      <TextField
                        multiline
                        onChange={(e: any) => {
                          setObservacion(e.currentTarget.value);
                        }}
                        disabled={estado === E_EstadoFormPrograma.Lectura}
                        defaultValue={observacion}
                        placeholder={observacionAnterior}
                        maxLength={1000}></TextField>
                      <span>{observacion.length}/1000</span>{" "}
                    </>
                  ) : (
                    <span>{observacion}</span>
                  )}
                </div>
                <div className="col-sm-12 col-md-12 col-lg-12 mb-1">
                  <label>Nota: Si el porcentaje obtenido es mayor o igual a 95%, el proceso se cerrará de manera automática.</label>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12 mt-3">
                  <button
                    hidden={
                      (estado === E_EstadoFormPrograma.Lectura && plan?.ID_ESTADO === E_EstadoPlanificacion.PlanInformado) ||
                      plan?.ID_ESTADO === E_EstadoPlanificacion.ResultadosEvaluacionInformados ||
                      plan?.ID_ESTADO === E_EstadoPlanificacion.AccionesAsignadas ||
                      plan?.ID_ESTADO === E_EstadoPlanificacion.EvidenciaEnviada ||
                      plan?.ID_ESTADO === E_EstadoPlanificacion.MedidasAprobadas ||
                      plan?.ID_ESTADO === E_EstadoPlanificacion.MedidasEnviadasProveedor ||
                      plan?.ID_ESTADO === E_EstadoPlanificacion.EvaluacionCerrada
                    }
                    type="button"
                    className="btn btn-sm btn-primary me-2"
                    onClick={() => handleGuardar(1)}
                    disabled={isSendingData}>
                    {" "}
                    Grabar
                  </button>
                  <button
                    hidden={
                      (estado === E_EstadoFormPrograma.Lectura && plan?.ID_ESTADO === E_EstadoPlanificacion.PlanInformado) ||
                      plan?.ID_ESTADO === E_EstadoPlanificacion.ResultadosEvaluacionInformados ||
                      plan?.ID_ESTADO === E_EstadoPlanificacion.AccionesAsignadas ||
                      plan?.ID_ESTADO === E_EstadoPlanificacion.EvidenciaEnviada ||
                      plan?.ID_ESTADO === E_EstadoPlanificacion.MedidasAprobadas ||
                      plan?.ID_ESTADO === E_EstadoPlanificacion.MedidasEnviadasProveedor ||
                      plan?.ID_ESTADO === E_EstadoPlanificacion.EvaluacionCerrada ||
                      porcentaje >= 95
                    }
                    type="button"
                    className="btn btn-sm btn-primary me-2"
                    onClick={() => handleGuardar(2)}
                    disabled={isSendingData}>
                    {" "}
                    Continuar
                  </button>
                  <button
                    hidden={estado === E_EstadoFormPrograma.Lectura || porcentaje < 95}
                    type="button"
                    className="btn btn-sm btn-primary me-2"
                    onClick={() => handleGuardar(2)}
                    disabled={isSendingData}>
                    {" "}
                    Cerrar evaluación
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => (window.location.href = "/proveedores/home")}
                    disabled={isSendingData}>
                    Volver
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
